import { Suspense, lazy } from 'react';
import { useProfileUiStore } from '../../store/profileUiStore';
import { useAuthStore } from '../../store/authStore';
// 글은 사전에서 온다 (2026-09-11) — 이 폴더(`components/**`)는 한글 하드코딩을 막는
// 검사(`check-no-hardcoded-korean-in-components.sh`)의 대상이다.
import { tShared } from '../../lib/shared-i18n';
import './SignatureHost.css';

/**
 * 내 서명 모달의 **전역 자리** (2026-08-29 · 판 8 잔여 ②).
 *
 * ★★ **왜 호스트가 필요한가.** 여는 곳이 프로필 팝오버인데, 그 팝오버는 모달이 열리는 순간
 *    닫힌다(설정과 같은 규칙 — 모달 뒤에 남은 팝오버는 유령처럼 보인다). 팝오버 안에서
 *    모달을 그리면 팝오버가 닫히면서 **모달까지 같이 사라진다**. 그래서 셸이 들고 있는다.
 *
 * ★★ **모달을 두 벌로 만들지 않는다.** 결재 시트가 쓰는 그 `SignatureModal` 을 그대로 연다 —
 *    두 벌이면 한쪽만 고쳐지는 날이 온다(판 8 이 정한 규칙·문구가 그 안에 들어 있다).
 *
 * ★ **필요할 때만 받아 온다**(`lazy`) — 서명은 대부분의 사람이 한 번도 안 여는 화면이고,
 *   캔버스·업로드까지 들고 있어 첫 화면 묶음에 넣을 이유가 없다.
 *
 * ★★★ **받아 오는 동안 «받아 오는 중» 이라고 말한다** (2026-09-11). 종전에는
 *    `fallback={null}` 이라 누르고 나서 **1초 넘게 아무 일도 안 일어났다** — 이 묶음을
 *    실제로 재 보니 **1,160ms** 였다(공용 컴포넌트·CSS·API 를 통째로 끌고 온다).
 *    이 앱의 다른 lazy 경계(게시판·메일·워크스페이스 문서 뷰어)는 전부 보이는 글을 둔다.
 *    아무 말도 안 하는 화면은 **「안 눌렸다」로 읽힌다.**
 *
 * ★ 그 글은 **사전에서 온다**(2026-09-11) — `components/**` 는 한글 하드코딩을 막는 검사의
 *   대상이고, #1151 에서 내가 그 규칙을 어겼다. 형제 lazy 경계들도 전부 사전을 쓴다.
 */
const SignatureModal = lazy(() =>
  import('../../pages/ApprovalPage/SignatureModal').then((m) => ({ default: m.SignatureModal })),
);

export function SignatureHost() {
  const open = useProfileUiStore((s) => s.signatureOpen);
  const close = useProfileUiStore((s) => s.closeSignature);
  const myName = useAuthStore((s) => s.user?.name ?? '');

  if (!open) return null;
  return (
    <Suspense
      fallback={(
        <div className="sigh__loading">
          <p className="sigh__loadingbox" role="status">{tShared('shared.signature.loading')}</p>
        </div>
      )}
    >
      <SignatureModal myName={myName} onClose={close} />
    </Suspense>
  );
}
